export default __webpack_public_path__ + "static/webpush-2c8eb139b3695d2cd37874becb8f63b3.png";